export const UserConstants = {
  ROLES: {
    admin: "admin",
    patient: "patient",
    corporate: "corporate",
    doctor: "doctor",
  },
};
